// extracted by mini-css-extract-plugin
export default {"container":"ka","overlay":"la","videoOverlay":"ma","header":"na","close":"oa","content":"pa"};